/**
 * Manually play a video to catch low power mode play error (not triggered onError).
**/

export default async function(video) {
	await video.play();
}
